import { render, staticRenderFns } from "./HandoverOtherTenancies.vue?vue&type=template&id=17dc24e6&scoped=true"
import script from "./HandoverOtherTenancies.vue?vue&type=script&lang=js"
export * from "./HandoverOtherTenancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc24e6",
  null
  
)

export default component.exports